import { useEffect, useMemo, useRef } from 'react';
import { useLazySearchBeneficiariesQuery } from '../services/benefitApi';
function useFilteredBeneficiariesQuery(voucherContractId, voucherTypeId, searchFilters) {
    const [triggerSearch, { data: searchData, isLoading: searchLoading, isError: searchError }] = useLazySearchBeneficiariesQuery();
    const searchFiltersKey = useMemo(() => JSON.stringify(searchFilters), [searchFilters]);
    const searchFiltersRef = useRef(searchFilters);
    useEffect(() => {
        searchFiltersRef.current = searchFilters;
    }, [searchFilters]);
    useEffect(() => {
        if (voucherContractId && voucherTypeId) {
            triggerSearch({
                voucherContractId,
                voucherTypeId,
                body: searchFiltersRef.current ?? {},
            });
        }
    }, [voucherContractId, voucherTypeId, searchFiltersKey, triggerSearch]);
    const beneficiaries = useMemo(() => searchData?.result ?? [], [searchData?.result]);
    const selected = useMemo(() => searchData?.selected ?? [], [searchData?.selected]);
    const total = useMemo(() => searchData?.total ?? 0, [searchData?.total]);
    const refetch = () => {
        if (voucherContractId && voucherTypeId) {
            triggerSearch({
                voucherContractId,
                voucherTypeId,
                body: searchFilters ?? {},
            });
        }
    };
    return {
        voucherBeneficiaries: beneficiaries,
        total,
        selected,
        isLoading: searchLoading,
        isError: !!searchError,
        refetch,
    };
}
export function useVoucherBeneficiaries({ voucherContractId, voucherTypeId, searchFilters, }) {
    const useFilteredQuery = Boolean(voucherContractId && voucherTypeId);
    const [triggerSearch] = useLazySearchBeneficiariesQuery();
    const filteredResult = useFilteredBeneficiariesQuery(useFilteredQuery ? voucherContractId : undefined, useFilteredQuery ? voucherTypeId : undefined, useFilteredQuery ? searchFilters : undefined);
    const searchSync = async (filters) => {
        if (!voucherContractId || !voucherTypeId) {
            return {
                beneficiaries: [],
                selected: [],
                total: 0,
            };
        }
        const result = await triggerSearch({
            voucherContractId,
            voucherTypeId,
            body: filters,
        }).unwrap();
        return {
            beneficiaries: result.result ?? [],
            selected: result.selected ?? [],
            total: result.total ?? 0,
        };
    };
    return {
        ...filteredResult,
        searchSync,
    };
}
